import React from 'react';
import { Col, Row } from '../../../../components/Bootstrap';
import { VenueTax } from '../../types';
import { Checkbox } from '../../../../components';

interface TaxRowProps {
  tax: VenueTax;
  isEditing: boolean;
  isChecked: boolean;
  onCheck(tax: VenueTax, checked: boolean): void;
}

export const TaxRow: React.FC<TaxRowProps> = ({ tax, isEditing, isChecked, onCheck }) => {
  return (
    <Row className='options-row mb-3'>
      <Col xs={5}>
        {tax.taxName} (${tax.taxPercentage}%)
      </Col>
      <Col xs={2}>
        <div className='d-flex align-items-center ps-3 h-100'>
          {isEditing && <Checkbox onClick={() => onCheck(tax, !isChecked)} isChecked={isChecked} />}
        </div>
      </Col>
    </Row>
  );
};
